import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import imageIcon from "../icons/AddFolder.svg";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";


export default class FileManagerPopup extends Plugin {
   static get requires() {
      return [Image, ImageUpload];
   }

   init() {
      var editor = this.editor;

      editor.ui.componentFactory.add("fileManagerPopup", locale => {
         const view = new ButtonView(locale);

         view.set({
            label: "FileManager",
            icon: imageIcon,
            tooltip: true
         });

         view.on("execute", () => {
            const popupUrl = stringFormat("/Resources/FileManager/FileManager.aspx?isFromCK=true&CKSelector={0}&currentSiteId={1}&rootFolderId={2}&rootFolderName={3}&ignoreUserPermissions={4}&filter={5}&showUploadAction={6}", editor.sourceElement.id, editor.config.get("currentSiteId"), editor.config.get("rootFolderId"), editor.config.get("rootFolderName"), editor.config.get("ignoreUserPermissions"), editor.config.get("filter"), editor.config.get("showUploadAction"));
            const popupOptions = "width=1150,height=650";

            window.open(popupUrl, "Popup", popupOptions);
         });

         return view;
      });

      window.addEventListener("message", function (event) {
         receiveMessageFromPopup(editor, event);
      });

      function receiveMessageFromPopup(editor, event) {

         if (typeof event.data == "string" && event.data.startsWith("FileManagerDataSentImage|")) {

            var data = event.data.split('|');

            //if (data[0] == "FileManagerDataSentImage" && data[1] == editor.sourceElement.id) {
            if (editor.sourceElement && data[1] == editor.sourceElement.id) {

               var imgTag = `<img src="${data[2]}" />`;

               const viewFragment = editor.data.processor.toView(imgTag);
               const modelFragment = editor.data.toModel(viewFragment);
               editor.model.insertContent(modelFragment);
            }

         }
      }

   }

}